// extracted by mini-css-extract-plugin
export default {"fullWidth":"Nn-z","image":"On-z","lazyLoadPicture":"Pn-z","lazyLoadSpinner":"Qn-z","lazyLoadSpin":"Rn-z","lazyLoadImage":"Sn-z","hasStyledAspectRatio":"Tn-z"};